import React, { useState } from 'react';
import { localApi } from '../utils/localApi';

export default function Login({ onLoginSuccess }: { onLoginSuccess: (session: any) => void }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const data = await localApi.login(email, password);
            onLoginSuccess(data.session);
        } catch (err: any) {
            setError(err.message || 'Identifiants incorrects. Veuillez réessayer.');
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-slate-950 flex flex-col items-center justify-center p-4 z-[9999]">
            {/* Background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-cyan-900/20 blur-[120px]" />
                <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-slate-800/40 blur-[100px]" />
            </div>

            <div className="relative z-10 w-full max-w-md">
                <div className="text-center mb-10">
                    <h1 className="text-4xl font-black text-white tracking-tighter italic uppercase mb-2">
                        ASTA <span className="text-cyan-500">RAIL</span>
                    </h1>
                    <p className="text-slate-400 text-sm font-medium tracking-widest uppercase">
                        Portail Sécurisé
                    </p>
                </div>

                <div className="bg-slate-900/80 backdrop-blur-xl border border-white/10 p-8 rounded-3xl shadow-2xl">
                    <form onSubmit={handleLogin} className="space-y-6">
                        {error && (
                            <div className="bg-red-500/10 border border-red-500/30 text-red-400 p-4 rounded-xl text-sm text-center">
                                {error}
                            </div>
                        )}

                        <div className="space-y-2">
                            <label className="text-[10px] text-cyan-500 font-bold uppercase tracking-widest ml-1">
                                Adresse E-mail Administrative
                            </label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-black/40 border border-white/10 rounded-2xl p-4 text-white placeholder:text-slate-600 focus:outline-none focus:border-cyan-500/50 transition-colors"
                                placeholder="ex: conducteur@nexus.cfc"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="text-[10px] text-cyan-500 font-bold uppercase tracking-widest ml-1">
                                Clé de Sécurité
                            </label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-black/40 border border-white/10 rounded-2xl p-4 text-white placeholder:text-slate-600 focus:outline-none focus:border-cyan-500/50 transition-colors font-mono"
                                placeholder="••••••••••••"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-cyan-600 hover:bg-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-black uppercase tracking-widest py-4 rounded-2xl shadow-lg shadow-cyan-900/50 transition-all active:scale-95"
                        >
                            {loading ? 'Authentification...' : 'Connexion'}
                        </button>
                    </form>

                    <div className="mt-8 text-center text-slate-500 text-[10px] uppercase tracking-widest">
                        Accès restreint au personnel autorisé
                    </div>
                </div>
            </div>
        </div>
    );
}

